import { Card } from 'primereact/card';
import React from 'react'
import Spinner from './Spinner';


const CardScreen: React.FC<React.PropsWithChildren<{ loading: boolean, className: string | undefined }>> = ({ children, className, loading }) => {
    if (loading) return (
        <Card className={className}>
            <Spinner />
        </Card>
    );

    return (
        <Card className={className}>
            { children }
        </Card>
    );
};


export default CardScreen